import styled from 'styled-components';

export const Icon = styled.img`
  width: 64px;
  border-radius: 15px;
`;
